import React from 'react';
import { Box, Typography } from '@mui/material';
import { CONTROL, PRES, SPACE, TYPE } from '../chrome';

interface AdminSettingCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

const AdminSettingCard: React.FC<AdminSettingCardProps> = ({ title, description, children }) => (
  <Box
    sx={{
      p: `${SPACE[5]}px`,
      bgcolor: PRES.surface,
      border: `1px solid ${PRES.borderSubtle}`,
      borderRadius: `${CONTROL.radiusCard}px`,
    }}
  >
    <Typography
      component="h3"
      sx={{ color: PRES.textPrimary, fontFamily: TYPE.ui, ...TYPE.title, fontSize: 14, mb: description ? 0.5 : 2 }}
    >
      {title}
    </Typography>
    {description && (
      <Typography sx={{ color: PRES.textSecondary, fontFamily: TYPE.ui, ...TYPE.body, mb: 2, maxWidth: 680 }}>
        {description}
      </Typography>
    )}
    {children}
  </Box>
);

export default AdminSettingCard;
